import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AuthGuard, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { CmsParagraphModule, PageComponentModule, PageSlotModule } from '@spartacus/storefront';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { KbCoreLookupComponent } from './KbcoreLookup/KbcoreLookup.component';
import { KbCoreShippingTabComponent } from './KbcoreShippingTab/KbcoreShippingTab.component';
import { KbCoreDocumentsTabComponent } from './kb-coreDocumentsTab/kb-coreDocumentsTab.component';
import { KbCoreMaterialTabComponent } from './KbcoreMaterialTab/KbcoreMaterialTab.component';
import { KbCoreReportsComponent } from './KbCoreReports/KbCoreReports.component';
import { KbMyAccountLeftSideNavModule } from '../kb-myAccount/my-account-left-sidenav/my-account-left-sidenav.module';
import { KbCustomerIdDropdownModule } from '../kb-myAccount/kb-MyOwnPartNumbers/customer-id-drop-down/customer-id-drop-down.module';
import { KbPipesModule } from 'src/app/pipes/kb-pipes.module';
import { KbMyCoreSubmitComponent } from './kb-myCoreSubmitComponent/kb-myCoreSubmit.component';
import { KbCoreGuidesTabComponent } from './KbcoreGuidesTab/KbcoreGuidesTab.component';
import { CoreDialogComponent } from './kb-myCoreSubmitComponent/core-dialog/core-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { KbPaginationModule } from '../kb-pagination/kb-pagination/kb-pagination.module';
import { CoreReportComponent } from './core-report/core-report.component';
import { KbLoaderModule } from '../loader/loader.module';
import { KbCoreReportsAnnouncementMxComponent } from './KbCoreReportsAnnouncementMx/KbCoreReportsAnnouncementMx.component';
@NgModule({
  declarations: [KbCoreGuidesTabComponent, KbCoreMaterialTabComponent,
    KbCoreShippingTabComponent, KbCoreDocumentsTabComponent,
    KbCoreReportsAnnouncementMxComponent,
    KbCoreLookupComponent, KbCoreReportsComponent,
    KbMyCoreSubmitComponent, CoreDialogComponent, CoreReportComponent],
  imports: [
    CommonModule,
    I18nModule,
    RouterModule,
    UrlModule,
    TabsModule,
    TooltipModule,
    AccordionModule,
    PageSlotModule,
    KbPaginationModule,
    PageComponentModule,
    FormsModule,
    KbPipesModule,
    MatDialogModule,
    PageSlotModule,
    ReactiveFormsModule,
    KbMyAccountLeftSideNavModule,
    KbCustomerIdDropdownModule,
    CmsParagraphModule,
    KbLoaderModule,
    ConfigModule.withConfig({
      cmsComponents: {

        KbCoreReportsFlexComponent: {
          component: KbCoreReportsComponent,
          guards: [SecureGuard, AuthGuard]
        },
        KbCoreSubmissionFlexComponent: {
          component: KbMyCoreSubmitComponent,
          guards: [SecureGuard, AuthGuard]
        },
        CoreReportsFlexComponent: {
          component: CoreReportComponent,
          guards: [SecureGuard]
        },
        KbCoreReportsAnnouncementFlexComponent: {
          component: KbCoreReportsAnnouncementMxComponent,
          guards: [SecureGuard]
        }
      }
    })
  ],

})
export class KbMyCoresModuleNA { }
